import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { UserAccountService } from '../_services/user-account.service';
import { SafeUser } from '../_models/safe-user';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';
import { UserOperatorsEditService } from '../_services/user-operators-edit.service';

@Component({
  selector: 'app-admin-edit-user',
  templateUrl: './admin-edit-user.component.html',
  styleUrls: ['./admin-edit-user.component.css']
})
export class AdminEditUserComponent implements OnInit {

  public userId: number;

  public userDetails: SafeUser = null;
  formGroup: FormGroup;

  public operatorJunctions: Array<any> = new Array<any>([]);

  constructor(
    private actRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    public userAccountService: UserAccountService,
    public userOperatorsEditService: UserOperatorsEditService,
    public dialog: MatDialog
  )
  {
    this.userId = this.actRoute.snapshot.params.userid;
  }

  ngOnInit(): void {

    //Fetch the user data
    this.userAccountService.adminFetchUser(this.userId).then((result: SafeUser) => {
      this.userDetails = result;

      var IsDenied = false;
      var IsApproved = false;
      var IsConfirmed = false;

      if (this.userDetails.IsConfirmed) IsConfirmed = false;
      if (this.userDetails.IsApproved) IsApproved = true;
      if (this.userDetails.IsDenied) IsDenied = true;

      //Build the form
      this.formGroup = this.formBuilder.group(
        {
          'Id': [this.userDetails.Id, []],
          'Email': [{ value: this.userDetails.Email, disabled: true }, []],
          'FirstName': [{ value: this.userDetails.FirstName, disabled: true }, []],
          'LastName': [{ value: this.userDetails.LastName, disabled: true }, []],
          'Phone': [{ value: this.userDetails.Phone, disabled: true }, []],
          'IsConfirmed': [this.userDetails.IsConfirmed, []],
          'IsApproved': [this.userDetails.IsApproved, []],
          'IsDenied': [this.userDetails.IsDenied, []],
          'Role': [this.userDetails.Role, []]
        }, {
        //validator: otherDataValidator()
      });
    },
      (err) => {
      });

    this.refreshOperators(); 
  }

  roleCompareFunction(o1: any, o2: any) {
    return (o1 == o2);
  }

  saveChanges(): void {
    var updatedValue = this.formGroup.value;

    this.userAccountService.adminUpdateUser(updatedValue).then(() => {

    },
    (err) => {
    });
  }

  resendConfirmationEmail() {
    this.userAccountService.resendConfirmationEmail(this.userDetails.Id).then(() => {
      this.dialog.open(MessageDialogComponent, {
        data: {
          title: "Success",
          message: "The confirmation email to this user was re-sent."
        }
      })
    },
      (err) => {
        this.dialog.open(MessageDialogComponent, {
          data: {
            title: "Success",
            message: "The confirmation email to this user was re-sent."
          }
        });
      });
  }

  refreshOperators() {
    //Load the user's operators.
    this.userOperatorsEditService.fetchUserOperators(this.userId).then((result: Array<any>) => {
      this.operatorJunctions = result;
    }); 
  }

  deleteOperatorJunction(oprjct: any) {
    this.userOperatorsEditService.removeOperatorJunction(this.userId, oprjct.OperatorId).then(() => {
      this.refreshOperators();
    },
    () => {

    });
  }

  approveUser(jct: any) {
    this.userOperatorsEditService.approveUserForOperator(jct).then(() => {
      this.refreshOperators();
    },
      () => {
        this.refreshOperators();
    });
  }

  unapproveUser(jct: any) {
    this.userOperatorsEditService.unapproveUserForOperator(jct).then(() => {
      this.refreshOperators();
    },
      () => {
        this.refreshOperators();
      });
  }

  grantApprover(jct: any) {
    this.userOperatorsEditService.grantApproverForUser(jct).then(() => {
      this.refreshOperators();
    },
    () => {
      this.refreshOperators();
    });
  }

  revokeApprover(jct: any) {
    this.userOperatorsEditService.revokeApproverForUser(jct).then(() => {
      this.refreshOperators();
    },
    () => {
      this.refreshOperators();
    });
  }
}
